module.exports = __webpack_public_path__ + "static/media/student-active.60977680.svg";